import { render } from "./ExternalMaterialsPanel.vue?vue&type=template&id=75c777d2&scoped=true"
import script from "./ExternalMaterialsPanel.vue?vue&type=script&lang=js"
export * from "./ExternalMaterialsPanel.vue?vue&type=script&lang=js"

import "./ExternalMaterialsPanel.vue?vue&type=style&index=0&id=75c777d2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c777d2"]])

export default __exports__